import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";
import { Sprig } from "./Botanical";

export const ProductIntro = () => (
    <section className="relative bg-cream py-16 sm:py-24" data-testid="product-intro-section">
        <div className="mx-auto grid max-w-5xl grid-cols-1 items-center gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:gap-16">
            <div>
                <Reveal>
                    <h2 className="font-serif text-2xl font-medium leading-snug text-plum sm:text-3xl lg:text-4xl">
                        Meet Your <em className="italic text-burgundy">5-Day Husband Reset</em> Guide
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="mt-6 max-w-lg text-base leading-relaxed text-mutedtext sm:text-lg">
                        A simple, easy-to-follow digital guide created for busy women who want to pause, reflect and
                        understand the relationship patterns affecting their emotional connection.
                    </p>
                    <p className="mt-5 max-w-lg text-base leading-relaxed text-mutedtext sm:text-lg">
                        No complicated theory. No long lectures.
                    </p>
                    <p className="mt-5 max-w-lg font-sans font-semibold text-plum sm:text-lg">
                        Just 5 simple days of guided reflection and practical connection-focused actions.
                    </p>
                </Reveal>
                <Reveal delay={0.2}>
                    <div className="mt-9">
                        <CtaButton testId="product-intro-cta-button">Yes, I Want the Guide &mdash; ₹49</CtaButton>
                    </div>
                </Reveal>
            </div>

            <Reveal delay={0.15} className="flex justify-center lg:justify-end">
                <motion.div
                    whileHover={{ rotate: -1.5, y: -6 }}
                    transition={{ type: "spring", stiffness: 260, damping: 20 }}
                    className="relative w-64 sm:w-72"
                    data-testid="product-pdf-mock"
                >
                    <div
                        aria-hidden
                        className="absolute -inset-4 rounded-3xl bg-[radial-gradient(circle_at_30%_20%,rgba(197,160,89,0.22),transparent_65%)]"
                    />
                    <div className="relative overflow-hidden rounded-2xl bg-plum shadow-2xl shadow-plum/30">
                        <div className="grain relative flex aspect-[3/4] flex-col items-center justify-between border border-gold/30 p-6 text-center">
                            <Sprig className="w-8 text-gold/70" />
                            <div>
                                <p className="font-sans text-[0.55rem] font-bold uppercase tracking-[0.3em] text-gold">
                                    The
                                </p>
                                <p className="mt-2 font-serif text-2xl font-medium leading-tight text-cream">
                                    5-Day Husband Reset Guide
                                </p>
                                <div className="mx-auto mt-4 h-px w-10 bg-gold/60" />
                                <p className="mt-4 font-sans text-[0.55rem] uppercase tracking-[0.22em] text-cream/70">
                                    Guided reflection &amp; connection exercises
                                </p>
                            </div>
                            <p className="font-serif text-lg italic text-gold">&#8377;49</p>
                        </div>
                    </div>
                    <span
                        className="absolute -right-3 -top-3 rounded-full border border-gold/50 bg-ivory px-3.5 py-1.5 font-sans text-[0.58rem] font-bold uppercase tracking-[0.2em] text-burgundy shadow-lg"
                        data-testid="product-pdf-format-chip"
                    >
                        Digital PDF
                    </span>
                </motion.div>
            </Reveal>
        </div>
    </section>
);

export default ProductIntro;
